import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'durata'
})

export class DurataPipe implements PipeTransform {
/**
     * setto la durata in base al parametro passato
     * @param  {number} value
     */
    transform(value: number): string {
        let durata: string = '<i class="clock outline icon" title="Durata"></i>'  + (value == null ? '0' : value.toString()) + ' gg';
        return durata;
    }
}